module.exports = __webpack_public_path__ + "img/vi_VN.b922c2f.webp";